import { useState } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

let CopyText = (props) => {
  const { text, t } = props;

  const [copied, setCopied] = useState(false);
  const [popupContent, setPopupContent] = useState(t('other_translation.copy'));
  const [open, setOpen] = useState(false);

  const handleCopyText = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        setPopupContent(t('other_translation.copied'));
        setOpen(true);
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        setTimeout(() => {
          setCopied(false);
          setPopupContent(t('other_translation.copy'));
          setOpen(false);
        }, 500);
      });
  };

  return (
    <Popup
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => {
        if (!copied) {
          setOpen(false);
        }
      }}
      trigger={
        <Icon
          className="activity-actions-warn ml-2"
          name="copy outline"
          onClick={() => {
            handleCopyText();
          }}
        />
      }
      content={popupContent}
      position="right center"
    />
  );
};

// Wrap component with withTranslation HOC
CopyText = withTranslation()(CopyText);

export default CopyText;
